import React, { FC } from 'react';

import { useGetPartnerDetailsQuery } from 'api';
import { getPartnerName, getPartnerRedirectUrl } from 'helpers';

import { PartnerShareError, PartnerShareLoader } from '../../components';
import { getShareConnectionOption, getShareDisplayOption } from '../../helpers';
import { ShareConnectionOption, ShareDisplayOption } from '../../types';

import Protected from './Protected';

const ProtectedLoader: FC = () => {
  const partnerName = getPartnerName();
  const displayOption = getShareDisplayOption();
  const connectionOption = getShareConnectionOption();

  const { data: partnerData, isLoading: isPartnerLoading } = useGetPartnerDetailsQuery(
    {
      partner_name: partnerName,
    },
    {
      enabled: !!partnerName,
    }
  );

  if (isPartnerLoading) {
    return <PartnerShareLoader />;
  }

  const redirectUrl = getPartnerRedirectUrl(partnerData?.getPartnerDetails);
  const validatedPartnerName = partnerData?.getPartnerDetails?.partner_name;

  if (displayOption === ShareDisplayOption.Page && !redirectUrl) {
    return <PartnerShareError message="redirect" />;
  }

  if (
    displayOption === ShareDisplayOption.iFrame &&
    connectionOption !== ShareConnectionOption.Popup
  ) {
    return <PartnerShareError message="iframe" />;
  }

  if (!validatedPartnerName) {
    return <PartnerShareError message="name" />;
  }

  return <Protected partnerName={validatedPartnerName} redirectUrl={redirectUrl} />;
};

export default ProtectedLoader;
